/**
 * DocumentSetEventSchemaName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EventSchemaName from '../../../../components/EventSchemaName';

// Selectors
import { makeSelectDocumentSetValue } from '../../../../services/documentSets/selectors';

interface Props {
    eventId?: number;
}

export class DocumentSetEventSchemaName extends React.PureComponent<Props> {
    render() {
        const { eventId } = this.props;
        if (!eventId) return null;
        return <EventSchemaName eventId={eventId} />;
    }
}

const mapStateToProps = createStructuredSelector({
    eventId: makeSelectDocumentSetValue('eventId')
});

export default connect(mapStateToProps)(DocumentSetEventSchemaName);
